import { AppController } from 'app/controllers';
import { Navigation } from 'app/services/navigation';
import { Routes } from 'src/types/routes';

import { computed, makeAutoObservable } from 'mobx';
import { AppViewModel } from '..';

export class SideMenuViewModel {
    constructor(){
        makeAutoObservable(this, {
            sideMenuLinksByRole: computed,
            sideMenuItems: computed,
        });
    }

    get error() { return AppController.Instance.Auth.error; }
    get isLoading() { return AppController.Instance.Auth.isLoading; }
    get isLoggedId() { return AppController.Instance.Auth.isLoggedIn; }
    get isMenuOpened() { return AppViewModel.Instance.isMenuOpened.value; }

    get sideMenuLinksByRole() {
        if (AppViewModel.Instance.userRole.isAdmin) {
            return [
                { title: 'campaigns', link: Routes.Dashboard.Campaigns, icon: 'note' },
                { title: 'users', link: Routes.Dashboard.Users, icon: 'users' },
            ];
        }

        return [
            { title: 'My Campaigns', link: Routes.Dashboard.Campaigns, icon: 'note' },
        ];
    }

    get sideMenuItems() {
        if (AppViewModel.Instance.userRole.isAdmin) {
            return [
                { title: 'Log out', onClick: this.handleLogout, icon: 'logout' },
            ];
        }

        return [
            { title: 'Help and FAQ’s', onClick: () => window.open(Routes.faq, '_blank'), icon: 'info' },
            { title: 'Log out', onClick: this.handleLogout, icon: 'logout' },
        ];
    }

    handleLogout = async () => {
        await AppController.Instance.Auth.logOut();

        if (!this.error) {
            Navigation.value.push(Routes.Dashboard.Login);
        }
    };

    handleCloseMenu = () => {
        AppViewModel.Instance.isMenuOpened.setFalse();
    };
}
